<template>
  <el-container>
    <div class="main">
      <div class="desc">{{$t('appleAuthDesc')}}</div>
      <div class="button">
          <el-button class="btnCancel" @click="BtnCancel()">{{$t('appleConfirmCancel')}}</el-button>
          <el-button class="btnContinue" @click="BtnContinue()">{{$t('appleConfirmContinue')}}</el-button>
      </div>
    </div>
  </el-container>
</template>
<script>
export default {
  name: 'appleConfirm',
  data () {},
  mounted () {},
  methods: {
    BtnCancel () {
      window.close()
    },
    BtnContinue () {
      let query = this.$route.query
      let appleAuthUrl = query.appleAuthUrl
      if (appleAuthUrl !== null) {
        window.location.href = appleAuthUrl
      }
    }
  }
}
</script>

<style scoped>
  .main {
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;     /* 垂直居中 */
    height: 100vh;          /* 使容器占满整个视口高度 */
    align-content: center;
    flex-wrap: wrap;
  }
  .desc {
    width: 100%;
    text-align: center;
    font-size: 17px;
    line-height: 1.47059;
    font-weight: 400;
  }
  .button {
    text-align: center;
    display: flex;
    margin-top: 20px;
  }
  .btnCancel {
    background: rgb(117, 117, 121);
    color: #FFFFFF;
    font-size: 17px;
    line-height: 1.17648;
    font-weight: 400;
    border-radius: 8px;
  }
  .btnContinue {
    background: rgb(0, 113, 227);
    color: #FFFFFF;
    font-size: 17px;
    line-height: 1.17648;
    font-weight: 400;
    margin-left: 10px;
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/module/appleConfirmPage.vue